<template>
<button class="btn btn-primary btn-sm" @click.prevent="subscribe">Subscribe now</button>
</template>

<script>
import axios from 'axios'
import SubscriptionDetails from './subscription'

export default {
  props: {
    subscription: String,
    fetchStatus: Function
  },
  data () {
    return {
      quadernoKey: 'pk_test_6nKoyMw4pgAGsxwNGasZ'
    }
  },
  created () {
    if (process.env.NODE_ENV === 'production') this.quadernoKey = 'pk_live_yKBtHxxNryAYoGWTxcUF'
    if (process.env.NODE_ENV === 'staging') this.quadernoKey = 'pk_live_yKBtHxxNryAYoGWTxcUF'
    var script = document.createElement('script')
    script.async = true
    script.src = 'https://checkout.quaderno.io/checkout.js';
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script)
  },
  methods: {
    subscribe () {
      const user = JSON.parse(localStorage.getItem('user'))
      let subscription = SubscriptionDetails[this.subscription]
      if (!subscription) return

      let handler = window.QuadernoCheckout.configure({
        key: this.quadernoKey,
        color: '#38a89d',
        callback: this.quadernoCallback
      })

      let options = {
        gateway: 'stripe',
        type: subscription.type,
        taxes: 'excluded',
        country: 'EE',
        currency: 'USD',
        // billing_address: true,
        // coupon: true,
        first_name: user.name.split(' ')[0] || '',
        last_name: user.name.split(' ')[1] || '',
        email: user.email,
        description: subscription.description,
        amount: subscription.amount
      }

      if (this.subscription === 'gooticsLifetime') {
        axios.get(`subscription/oneofftoken`).then((res) => {
          if (res.status === 200) {
            options.callback = this.quadernoCallback
            options.charge = res.data
            handler.open(options)
          }
        })
      } else {
        options.callback = this.quadernoCallback
        options.plan = subscription.plan
        handler.open(options)
      }
    },
    quadernoCallback (data) {
      data.planId = this.subscription
      // let subscription = SubscriptionDetails[this.subscription]
      axios.put(`user/subscription`, data).then((res) => {
        if (res.status === 200) {
          axios.get(`subscription/substatus`).then((subscription) => {
            if (subscription.status === 200) { localStorage.setItem('subscription', JSON.stringify(subscription.data)) }
          })
          axios.get(`user`).then((user) => {
            // this.$gtm.trackEvent({
            //   event: 'subscription',
            //   category: 'subscription',
            //   action: 'User Subscribed',
            //   label: subscription.plan,
            //   value: (subscription.amount / 100)
            // })
            localStorage.setItem('user', JSON.stringify(user.data))
            this.fetchStatus()
          })
        }
      })
    }
  }
}
</script>

<style>
.custom-quaderno-button {
    box-shadow: none !important;
    padding: 0.7rem 2.5rem;
    font-size: 1rem;
    border-radius: 1.875rem;
    font-family: inherit;
    letter-spacing: 3px;
    text-transform: uppercase;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/SubscribeBtn.vue